var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.init)?_c('div',{staticClass:"highlight"},[(_vm.finalDecision === _vm.finalDecisions.approved)?_c('ApprovedByHO'):_vm._e(),(_vm.finalDecision === _vm.finalDecisions.rejected)?_c('RejectedByHO'):_vm._e(),(!_vm.finalDecision)?_c('Hello'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }